import { makeAutoObservable } from 'mobx';
import { INotification, NotificationType, SnackbarPosition } from '../interfaces/template/INotification';

class SnackbarStore {
  constructor() {
    makeAutoObservable(this);
  }

  timeout?: ReturnType<typeof setTimeout>;

  public notification: INotification = undefined;

  public pushNotification = (message: string, type: NotificationType, position?: SnackbarPosition, timeoutValue: number = 5000) => {
    const id = Math.random();
    this.notification = {
      message,
      type,
      position,
      id,
    };

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (timeoutValue) {
      this.timeout = setTimeout(() => {
        this.clearNotification();
      }, timeoutValue);
    }
  };

  public clearNotification = () => {
    this.notification = undefined;
  };
}

export default SnackbarStore;
